// @ts-nocheck
export const RESOURCES_LOAD_BASE_CURRENCY_CATALOG = 'RESOURCES_LOAD_BASE_CURRENCY_CATALOG';
export const RESOURCES_LOAD_USER_ROLES = 'RESOURCES_LOAD_USER_ROLES';
export const RESOURCES_LOAD_USER_PARTNERS = 'RESOURCES_LOAD_USER_PARTNERS';
export const RESOURCES_LOAD_USER_TYPES = 'RESOURCES_LOAD_USER_TYPES';
export const RESOURCES_SET_BASE_CURRENCY_CATALOG = 'RESOURCES_SET_BASE_CURRENCY_CATALOG';
export const RESOURCES_SET_USER_ROLES = 'RESOURCES_SET_USER_ROLES';
export const RESOURCES_SET_USER_PARTNERS = 'RESOURCES_SET_USER_PARTNERS';
export const RESOURCES_SET_USER_TYPES = 'RESOURCES_SET_USER_TYPES';
export const RESOURCES_CLEAN = 'RESOURCES_CLEAN';
export const RESOURCES_LOAD_BUSINESS_UNITS = 'RESOURCES_LOAD_BUSINESS_UNITS';
export const RESOURCES_SET_BUSINESS_UNITS = 'RESOURCES_SET_BUSINESS_UNITS';
export const RESOURCES_LOAD_BUSINESS_INSIGHTS_SITE_VIEWS = 'RESOURCES_LOAD_BUSINESS_INSIGHTS_SITE_VIEWS';
export const RESOURCES_SET_BUSINESS_INSIGHTS_SITE_VIEWS = 'RESOURCES_SET_BUSINESS_INSIGHTS_SITE_VIEWS';

export const loadBaseCurrencyCatalog = () => {
  return { type: RESOURCES_LOAD_BASE_CURRENCY_CATALOG };
};

export const loadUserRoles = () => {
  return { type: RESOURCES_LOAD_USER_ROLES };
};

export const loadUserEditorUserPartners = () => {
  return { type: RESOURCES_LOAD_USER_PARTNERS };
};

export const loadUserEditorUserTypes = () => {
  return { type: RESOURCES_LOAD_USER_TYPES };
};

export const setBaseCurrencyCatalog = baseCurrencyCatalog => {
  return {
    data: { baseCurrencyCatalog },
    type: RESOURCES_SET_BASE_CURRENCY_CATALOG
  };
};

export const setUserRoles = userRoles => {
  return {
    data: { userRoles },
    type: RESOURCES_SET_USER_ROLES
  };
};

export const setUserPartners = userPartners => {
  return {
    data: { userPartners },
    type: RESOURCES_SET_USER_PARTNERS
  };
};

export const setUserTypes = userTypes => {
  return {
    data: { userTypes },
    type: RESOURCES_SET_USER_TYPES
  };
};

export const cleanResources = () => {
  return { type: RESOURCES_CLEAN };
};

export const loadBusinessUnits = () => {
  return { type: RESOURCES_LOAD_BUSINESS_UNITS };
};

export const setBusinessUnits = businessUnits => {
  return {
    data: { businessUnits },
    type: RESOURCES_SET_BUSINESS_UNITS
  };
};

export const loadBusinessInsightsSiteViews = () => {
  return { type: RESOURCES_LOAD_BUSINESS_INSIGHTS_SITE_VIEWS };
};

export const setBusinessInsightsSiteViews = businessInsightsSiteViews => {
  return {
    data: { businessInsightsSiteViews },
    type: RESOURCES_SET_BUSINESS_INSIGHTS_SITE_VIEWS
  };
};
